export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6396.9bd35384.jpg";